import { isInstallationType } from "./installation";

type Schedule = {
  type?: string;
  due_date?: string | null;
  scheduled_start?: string | null;
  scheduled_end?: string | null;
};

export function postponeDeadline(
  value: string,
  days: number,
  now = new Date(),
) {
  const previous = new Date(value);
  const next = new Date(now);
  next.setDate(next.getDate() + days);
  if (Number.isFinite(previous.getTime()))
    next.setHours(previous.getHours(), previous.getMinutes(), 0, 0);
  return next.toISOString();
}
/** Legacy deadline callers keep their duration; the period end is the deadline. */
export function requireTaskSchedule<T extends Schedule>(
  data: T,
  previous?: Schedule,
): T & Schedule {
  if (isInstallationType(data.type)) return data;
  const deadline =
    data.due_date || data.scheduled_end
      ? new Date(data.due_date || data.scheduled_end!).getTime()
      : NaN;
  if (!Number.isFinite(deadline))
    throw new Error("Укажите срок выполнения задачи");
  const deadlineChanged = previous && data.due_date !== previous.due_date;
  const timesUnchanged =
    previous &&
    data.scheduled_start === previous.scheduled_start &&
    data.scheduled_end === previous.scheduled_end;
  if (
    !data.scheduled_start ||
    !data.scheduled_end ||
    (deadlineChanged && timesUnchanged)
  ) {
    return {
      ...data,
      due_date: new Date(deadline).toISOString(),
      scheduled_start: new Date(
        deadline -
          (previous?.scheduled_start && previous.scheduled_end
            ? Math.max(
                60000,
                new Date(previous.scheduled_end).getTime() -
                  new Date(previous.scheduled_start).getTime(),
              )
            : 3600000),
      ).toISOString(),
      scheduled_end: new Date(deadline).toISOString(),
    };
  }
  const start = new Date(data.scheduled_start).getTime(),
    end = new Date(data.scheduled_end).getTime();
  if (!Number.isFinite(start) || !Number.isFinite(end) || end <= start)
    throw new Error("Окончание должно быть позже начала");
  return { ...data, due_date: new Date(end).toISOString() };
}
